const genAnswer = function (qu, value, refItem) {
  const filterArr = qu.optionList.filter(item => item.value !== 0).map(item => {
    return {
      descId: item.id,
      answer: item.value || (item.optionList && item.optionList.length && item.optionList[0].value ? item.optionList[0].value : '' )
    }
  })
  return filterArr.filter(item => item.answer.trim())
}

const setAnswer = function (qu, valueMap, otherAnswerMap) {
  let configValue = []
  Object.keys(valueMap).forEach(key => {
    const value = valueMap[key].join('')
    if (value) {
      configValue.push(value)
    }
    const optionItem = this.optionList.find(item => item.id === key)
    if (optionItem) {
      if (value === '-999' && optionItem.optionList && optionItem.optionList.length) {
        // 不清楚/不知道
        optionItem.optionList[0].value = value
      } else {
        optionItem.value = value
      }
    }
  })
  this.value = configValue
}

const answer = {
  genAnswer,
  setAnswer
}

export default answer



// WEBPACK FOOTER //
// ./src/components/editor/MultiNumberBox/answer.js